import React, { useRef, useState, useEffect } from 'react';
import html2pdf from 'html2pdf.js';
import saloraLogo from '../../assets/img/salora_logo.jpg'; // 🔁 update path if needed
import { resolveApr } from '../../util/apr';

const LoanAgreement = () => {
    const pdfRef = useRef();
    const headerRef = useRef();
    const [applicationId, setApplicationId] = useState('');
    const [token, setToken] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [otpValue, setOtpValue] = useState('');
    const [isEsigned, setIsEsigned] = useState(false);
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [esignData, setEsignData] = useState({
        otpSentTo: '',
        otpEnteredOnAppAt: '',
        deviceUsed: '',
        ipAddress: '',
        digitallyAcceptedBy: ''
    });
    const [agreement, setAgreement] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [redirectUrl, setRedirectUrl] = useState('');


    // const approval = data?.approval || {};
    // const customer = data?.customerDetails || {};
    // const fintech = data?.fintechDetails || {};
    // const repayment = data?.approvalRepayment || [];

    useEffect(() => {
        // extract applicationId from URL query params
        try {
            const params = new URLSearchParams(window.location.search);
            const id = params.get('applicationId') || params.get('application_id') || '';
            setApplicationId(id);
        } catch (e) {
            // ignore in non-browser contexts
        }
        // try to pick token from localStorage if available
        const saved = typeof window !== 'undefined' && (localStorage.getItem('token') || localStorage.getItem('authToken') || localStorage.getItem('accessToken'));
        if (saved) setToken(saved);
        // if applicationId already marked esigned in localStorage, mark locally so button won't reappear
        try {
            if (typeof window !== 'undefined') {
                const key = applicationId ? `esign_done_${applicationId}` : null;
                if (key) {
                    const stored = localStorage.getItem(key);
                    if (stored) {
                        const parsed = JSON.parse(stored);
                        if (parsed && parsed.done) {
                            setIsEsigned(true);
                            if (redirectUrl) {
                                setTimeout(() => {
                                    window.location.replace(redirectUrl);
                                }, 1500); // 1.5 sec delay so user sees success message
                            }
                            // populate ip and name if present
                            setEsignData((prev) => ({ ...prev, ipAddress: parsed.ip || prev.ipAddress || '', digitallyAcceptedBy: parsed.digitallyAcceptedBy || prev.digitallyAcceptedBy || '' }));
                        }
                    }
                }
            }
        } catch (err) {
            // ignore localStorage errors
        }
    }, []);

    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);

            const id =
                params.get('applicationId') ||
                params.get('application_id') ||
                '';
            setApplicationId(id);

            const redirect =
                params.get('redirectUrl') ||
                params.get('redirect_url') ||
                '';

            if (redirect) {
                setRedirectUrl(decodeURIComponent(redirect));
            }
        } catch (e) { }
    }, []);

    useEffect(() => {
        if (isEsigned && redirectUrl) {
            setTimeout(() => {
                window.location.replace(redirectUrl);
            }, 1000);
        }
    }, [isEsigned, redirectUrl]);

    // watch for applicationId changes to re-check localStorage (in case app id comes from URL later)
    useEffect(() => {
        try {
            if (typeof window !== 'undefined' && applicationId) {
                const key = `esign_done_${applicationId}`;
                const stored = localStorage.getItem(key);
                if (stored) {
                    const parsed = JSON.parse(stored);
                    if (parsed && parsed.done) {
                        setIsEsigned(true);
                        setEsignData((prev) => ({ ...prev, ipAddress: parsed.ip || prev.ipAddress || '', digitallyAcceptedBy: parsed.digitallyAcceptedBy || prev.digitallyAcceptedBy || '' }));
                    }
                }
            }
        } catch (err) {
            // ignore
        }
    }, [applicationId]);

    // fetch agreement details when applicationId is available
    // useEffect(() => {
    //     const fetchAgreement = async () => {
    //         if (!applicationId) return;
    //         try {
    //             // setStatusMessage('Loading agreement details...');
    //             const resp = await fetch(`https://lmsjava.saloracapital.com/agreement/details?applicationId=${encodeURIComponent(applicationId)}`);

    //             // if (!resp.ok) {
    //             //     // Show friendly message if agreement cannot be loaded
    //             //     //setModalMessage('Agreement is not yet available. Your loan might not be approved yet.');
    //             //     setShowModal(true);
    //             //     return;
    //             // }

    //             const data = await resp.json();
    //             setAgreement(data || null);

    //             // if (!data || !data.eSign) {
    //             //     setModalMessage('Agreement is not yet available. Your loan might not be approved yet.');
    //             //     setShowModal(true);
    //             //     return;
    //             // }

    //             // Fallback: fetch public IP if backend didn't provide
    //             // let publicIp = data.eSign.ipAddress || '';
    //             // if (!publicIp) {
    //             //     try {
    //             //         publicIp = await fetchPublicIp();
    //             //     } catch (e) {
    //             //         publicIp = '';
    //             //     }
    //             // }

    //             // Populate eSign data
    //             // setEsignData((prev) => ({
    //             //     ...prev,
    //             //     otpSentTo: data.eSign.phoneNumber || prev.otpSentTo,
    //             //     otpEnteredOnAppAt: data.eSign.esignDate || prev.otpEnteredOnAppAt,
    //             //     digitallyAcceptedBy: data.eSign.name || prev.digitallyAcceptedBy,
    //             //     deviceUsed: data.eSign.deviceName || prev.deviceUsed || (navigator && navigator.userAgent ? navigator.userAgent : ''),
    //             //     ipAddress: data.eSign.ipAddress || prev.ipAddress || '',
    //             // }));

    //             if (data && data.eSign) {
    //                 setEsignData((prev) => ({
    //                     ...prev,
    //                     otpSentTo: data.eSign.phoneNumber || prev.otpSentTo || '',
    //                     otpEnteredOnAppAt: data.eSign.esignDate || prev.otpEnteredOnAppAt || '',
    //                     digitallyAcceptedBy: data.eSign.name || prev.digitallyAcceptedBy || '',
    //                     deviceUsed: data.eSign.deviceName || prev.deviceUsed || '',
    //                     ipAddress: data.eSign.ipAddress || prev.ipAddress || '',
    //                 }));
    //             }

    //             // Mark as e-signed locally if backend shows esignDate
    //             // if (data.eSign.esignDate) {
    //             //     try {
    //             //         const key = applicationId ? `esign_done_${applicationId}` : null;
    //             //         const payload = {
    //             //             done: true,
    //             //             ip: data.eSign.ipAddress || '',
    //             //             digitallyAcceptedBy: data.eSign.name || ''
    //             //         };
    //             //         if (key) localStorage.setItem(key, JSON.stringify(payload));
    //             //         setIsEsigned(true);
    //             //         if (redirectUrl) {
    //             //             setTimeout(() => {
    //             //                 window.location.replace(redirectUrl);
    //             //             }, 1500); // 1.5 sec delay so user sees success message
    //             //         }
    //             //     } catch (e) { }
    //             // }

    //             setStatusMessage(''); // Clear any previous messages
    //         } catch (err) {
    //             // Friendly error message if fetch fails
    //             // setModalMessage('Agreement is not available at the moment. Your loan might not be approved yet.');
    //             // setShowModal(true);
    //         }
    //     };

    //     fetchAgreement();
    // }, [applicationId]);






    useEffect(() => {
    if (!applicationId) return;

    const controller = new AbortController();

    const fetchAgreement = async () => {
        try {
            setStatusMessage('Loading agreement details...');

            // 👉 Prod base URLs only (dev fallback removed)
            const baseUrls = [
                "https://lsmjava.saloracapital.com",
                "https://lmsapi.saloracapital.com"
            ];

            let response = null;
            let lastError = null;

            for (const baseUrl of baseUrls) {
                try {
                    const url = `${baseUrl}/agreement/details?applicationId=${encodeURIComponent(applicationId)}`;
                    
                    response = await fetch(url, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        signal: controller.signal
                    });

                    if (response.ok) break; // stop if success
                } catch (err) {
                    lastError = err;
                }
            }

            if (!response || !response.ok) {
                throw new Error("Agreement not found or server error");
            }

            // 👉 Safe JSON parsing
            let data = null;
            try {
                data = await response.json();
            } catch (err) {
                throw new Error("Invalid JSON response");
            }

            if (!data) {
                setAgreement(null);
                setStatusMessage("Agreement not available yet.");
                return;
            }

            setAgreement(data);

            // 👉 Handle eSign safely
            if (data?.eSign) {
                setEsignData((prev) => ({
                    ...prev,
                    otpSentTo: data.eSign.phoneNumber ?? prev.otpSentTo ?? '',
                    otpEnteredOnAppAt: data.eSign.esignDate ?? prev.otpEnteredOnAppAt ?? '',
                    digitallyAcceptedBy: data.eSign.name ?? prev.digitallyAcceptedBy ?? '',
                    deviceUsed: data.eSign.deviceName ?? prev.deviceUsed ?? navigator.userAgent ?? '',
                    ipAddress: data.eSign.ipAddress ?? prev.ipAddress ?? '',
                }));
            } else {
                setStatusMessage("Agreement available but not e-signed yet.");
            }

            setStatusMessage('');

        } catch (error) {
            console.error("Agreement fetch error:", error);
            setStatusMessage("Unable to load agreement. Please try again later.");
            setAgreement(null);
        }
    };

    fetchAgreement();

    return () => {
        controller.abort(); // cleanup
    };

}, [applicationId]);


    // helper: fetch public IP (best-effort)
    // const fetchPublicIp = async () => {
    //     try {
    //         const controller = new AbortController();
    //         const id = setTimeout(() => controller.abort(), 5000);
    //         const r = await fetch('https://api.ipify.org?format=json', { signal: controller.signal });
    //         clearTimeout(id);
    //         if (!r.ok) return '';
    //         const j = await r.json();
    //         return j.ip || '';
    //     } catch (e) {
    //         return '';
    //     }
    // };

    const getAuthHeader = () => {
        if (token && token.trim()) return { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` };
        return {};
    };
    // small helpers to map enums to human readable
    const mapGender = (g) => {
        if (g === 1) return 'Male';
        if (g === 2) return 'Female';
        return '';
    };
    const mapRepaymentType = (r) => {
        if (r === 1) return 'Daily';
        if (r === 2) return 'Weekly';
        if (r === 3) return 'Monthly';
        if (r === 4) return 'Bullet';
        return 'As per KFS';
    };
    const mapRepaymentTypePA = (r) => {
        if (r === 1) return 'Per Day';
        if (r === 2) return 'Per Week';
        if (r === 3) return 'Per Month';
        if (r === 4) return 'Lump Sum at End of Term';
        return 'As per KFS';
    };
    const mapRoiType = (r) => {
        if (r === 1) return 'Reducing';
        if (r === 2) return 'Flat';
        return 'As per KFS';
    };
    const mapRoi = (r) => {
        if (r === 1) return 365;
        if (r === 2) return 52;
        if (r === 3) return 12;
        if (r === 4) return 1;
        return 'As per KFS';
    };
    const mapMarital = (r) => {
        if (r === 1) return "Married";
        if (r === 2) return "Single";
        if (r === 3) return "Divorced";
        if (r === 4) return "Widowed";
        return 'As per KFS';
    };
    const getInstallmentAmount = () => {
        try {
            const first = agreement?.approvalRepayments && agreement.approvalRepayments.find((x) => Number(x.emiNumber) === 1);
            if (first && first.emiAmount) return first.emiAmount;
            if (agreement?.approval?.emiAmount) return agreement.approval.emiAmount;
            return '';
        } catch (e) {
            return '';
        }
    };
    const getInstallmentStartDate = () => {
        try {
            if (agreement?.approval?.emiDate) return agreement.approval.emiDate;
            const first = agreement?.approvalRepayments && agreement.approvalRepayments.find((x) => Number(x.emiNumber) === 1);
            return (first && first.emiDate) || '';
        } catch (e) { return ''; }
    };
    const downloadPDF = () => {
        const element = pdfRef.current;
        const headerEl = headerRef.current;

        const opt = {
            margin: [0.5, 0.5],
            filename: 'Loan_Agreement.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        };

        // Hide the header inside the pdf container and global UI chrome (navbar/sidebar/dropdowns)
        // before generating the PDF so they don't appear in the saved agreement. Restore afterwards.
        let prevDisplayHeader;
        let prevDisplayNavbar;
        let prevDisplaySidenav;
        const prevDropdownDisplays = [];
        try {
            if (headerEl) {
                prevDisplayHeader = headerEl.style.display;
                headerEl.style.display = 'none';
            }

            // hide global navbar (id from AdminNavbar)
            const navbarEl = typeof document !== 'undefined' && document.getElementById('navbar-main');
            if (navbarEl) {
                prevDisplayNavbar = navbarEl.style.display;
                navbarEl.style.display = 'none';
            }

            // hide sidebar (id from Sidebar)
            const sidenavEl = typeof document !== 'undefined' && document.getElementById('sidenav-main');
            if (sidenavEl) {
                prevDisplaySidenav = sidenavEl.style.display;
                sidenavEl.style.display = 'none';
            }

            // hide any open dropdown menus that might overlay (e.g., user menu)
            const dropdowns = typeof document !== 'undefined' && Array.from(document.querySelectorAll('.dropdown-menu.show'));
            if (dropdowns && dropdowns.length) {
                dropdowns.forEach((d) => {
                    prevDropdownDisplays.push({ el: d, display: d.style.display });
                    d.style.display = 'none';
                });
            }

            const instance = html2pdf().set(opt).from(element).save();

            const restoreAll = () => {
                if (headerEl) headerEl.style.display = prevDisplayHeader || '';
                if (navbarEl) navbarEl.style.display = prevDisplayNavbar || '';
                if (sidenavEl) sidenavEl.style.display = prevDisplaySidenav || '';
                if (prevDropdownDisplays.length) {
                    prevDropdownDisplays.forEach(({ el, display }) => {
                        el.style.display = display || '';
                    });
                }
            };

            // html2pdf.save() returns a promise in many builds — restore on completion.
            if (instance && typeof instance.then === 'function') {
                instance.then(restoreAll).catch((e) => {
                    restoreAll();
                    console.error('Error generating PDF', e);
                });
            } else {
                // Fallback: restore after a short delay if no promise is returned
                setTimeout(() => {
                    restoreAll();
                }, 1000);
            }
        } catch (err) {
            // Ensure we restore UI if something goes wrong
            try {
                if (headerEl) headerEl.style.display = prevDisplayHeader || '';
                const navbarEl = typeof document !== 'undefined' && document.getElementById('navbar-main');
                if (navbarEl) navbarEl.style.display = prevDisplayNavbar || '';
                const sidenavEl = typeof document !== 'undefined' && document.getElementById('sidenav-main');
                if (sidenavEl) sidenavEl.style.display = prevDisplaySidenav || '';
                if (prevDropdownDisplays.length) {
                    prevDropdownDisplays.forEach(({ el, display }) => {
                        el.style.display = display || '';
                    });
                }
            } catch (restoreErr) {
                console.error('Error restoring UI after PDF error', restoreErr);
            }
            console.error('Error generating PDF', err);
        }
    };

    // Generate OTP (also used for resend)
    const generateOtp = async (isResend = false) => {
        if (!applicationId) {
            setStatusMessage('Missing applicationId in URL.');
            return;
        }
        setLoading(true);
        setStatusMessage(isResend ? 'Resending OTP...' : 'Sending OTP...');
        try {
            const headers = {
                // backend expects form data or empty body for OTP generation in some setups; keep JSON safe but allow bearer header
                'Content-Type': 'application/json',
                ...getAuthHeader()
            };
            const resp = await fetch(`https://lspapi.saloracapital.com/api/eSign/otp?applicationId=${encodeURIComponent(applicationId)}`, {
                method: 'POST',
                headers,
            });
            if (!resp.ok) {
                const text = await resp.text();
                setStatusMessage(`Failed to send OTP: ${resp.status} ${text}`);
                setLoading(false);
                return;
            }
            // assume OTP sent
            setOtpSent(true);
            setShowOtpInput(true);
            setStatusMessage(isResend ? 'OTP resent. Please check the user\'s device.' : "OTP sent. Please check the user's device and enter the OTP below.");
        } catch (err) {
            setStatusMessage('Error sending OTP: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    // Verify OTP and mark
    const verifyOtp = async () => {
        if (!applicationId) {
            setStatusMessage('Missing applicationId in URL.');
            return;
        }
        if (!otpValue) {
            setStatusMessage('Please enter the OTP.');
            return;
        }
        setLoading(true);
        setStatusMessage('Verifying OTP...');
        try {
            // Backend expects application/x-www-form-urlencoded (see user's curl). Send body accordingly
            const body = new URLSearchParams();
            body.append('applicationId', applicationId);
            body.append('enteredOtp', otpValue);

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                // mirror a reasonable User-Agent; some backends validate it
                'User-Agent': (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : 'MyDevice/Chrome',
                ...getAuthHeader()
            };

            const url = `https://lspjava.saloracapital.com/api/eSign/verifyAndMark`;
            const resp = await fetch(url, { method: 'POST', headers, body: body.toString() });
            const text = await resp.text();
            if (!resp.ok) {
                setStatusMessage(`OTP verification failed: ${resp.status} ${text}`);
                setLoading(false);
                return;
            }
            // try parse JSON response if any
            let data = {};
            try { data = JSON.parse(text || '{}'); } catch (e) { data = {}; }

            // populate esignData from response or fallback
            const now = new Date().toLocaleString();
            // try to fetch public IP (best effort) if backend didn't provide
            // let publicIp = data.ipAddress || '';
            // if (!publicIp) {
            //     try {
            //         publicIp = await fetchPublicIp();
            //     } catch (e) {
            //         publicIp = '';
            //     }
            // }

            setEsignData((prev) => ({
                otpSentTo: data.otpSentTo || prev.otpSentTo || '',
                otpEnteredOnAppAt: data.otpEnteredOnAppAt || now,
                deviceUsed: data.deviceName || data.deviceUsed || (navigator && navigator.userAgent ? navigator.userAgent : ''),
                ipAddress: data.ipAddress || prev.ipAddress || '',
                digitallyAcceptedBy: data.digitallyAcceptedBy || prev.digitallyAcceptedBy || ''
            }));


            // If response contains borrower name, use it for signature area
            if (data.digitallyAcceptedBy) {
                setEsignData((prev) => ({ ...prev, digitallyAcceptedBy: data.digitallyAcceptedBy }));
            } else {
                // try to extract borrower name from page (a fallback)
                const borrower = document.querySelector('td') && document.querySelectorAll('td')[1] ? document.querySelectorAll('td')[1].textContent : '';
                if (borrower) setEsignData((prev) => ({ ...prev, digitallyAcceptedBy: prev.digitallyAcceptedBy || borrower }));
            }


            try {
                const key = applicationId ? `esign_done_${applicationId}` : null;
                const payload = {
                    done: true,
                    ip: data.eSign.ipAddress || '',
                    digitallyAcceptedBy: data.digitallyAcceptedBy || ''
                };
                if (key) localStorage.setItem(key, JSON.stringify(payload));
            } catch (e) {
                // ignore localStorage errors
            }

            setIsEsigned(true);
            setShowOtpInput(false);
            setStatusMessage('OTP verified and e-sign applied.');

            // redirect if needed


            setStatusMessage('OTP verified and e-sign applied.');
            setShowOtpInput(false);

            if (redirectUrl) {
                setTimeout(() => {
                    window.location.replace(redirectUrl);
                }, 1500);
            }
            // mark locally as esigned so the button is hidden persistently
            try {
                const key = applicationId ? `esign_done_${applicationId}` : null;
                const payload = { done: true, ip: data.eSign.ipAddress || '', digitallyAcceptedBy: data.digitallyAcceptedBy || '' };
                if (key) localStorage.setItem(key, JSON.stringify(payload));
            } catch (e) {
                // ignore storage issues
            }
            setIsEsigned(true);
            if (redirectUrl) {
                setTimeout(() => {
                    window.location.replace(redirectUrl);
                }, 1500); // 1.5 sec delay so user sees success message
            }
        } catch (err) {
            setStatusMessage('Error verifying OTP: ' + err.message);
        } finally {
            setLoading(false);
        }
    };



    return (

        //         <div style={{ fontFamily: 'Arial', fontSize: '12pt', lineHeight: '1.5', padding: '20px', backgroundColor: "#fff"  ,   minHeight: '100vh',
        //  }}>

        <div
            style={{
                minHeight: '100vh',
                backgroundColor: '#f2f2f2',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '10px',
            }}
        >
            {/* Main Container */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '900px',
                    height: '85vh',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 0 12px rgba(0,0,0,0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '80px',
                }}
            >

                {/* 🔒 FIXED HEADER */}
                <div
                    ref={headerRef}
                    style={{
                        padding: '14px 16px',
                        borderBottom: '1px solid #e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        backgroundColor: '#fff',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                    }}
                >
                    <img
                        src={saloraLogo}
                        alt="Salora Logo"
                        style={{ height: '42px' }}
                    />

                    
                </div>

                {/* 📜 STATUS MESSAGE (OPTIONAL) */}
                {statusMessage && (
                    <div
                        style={{
                            padding: '8px 16px',
                            fontSize: '12px',
                            color: '#333',
                            backgroundColor: '#fafafa',
                            borderBottom: '1px solid #eee',
                        }}
                    >
                        {statusMessage}
                    </div>
                )}

                {/* 📄 SCROLLABLE CONTENT */}
                <div
                    ref={pdfRef}
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '16px',
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '13px',
                        lineHeight: '1.6',
                        color: '#000',
                    }}
                >
                    <div>
                        <div style={{ fontSize: '15px', fontWeight: '700', textAlign: 'center' }}>
                            LOAN AGREEMENT
                        </div>
                        <div style={{ fontSize: '11px', color: '#666', textAlign: 'center', marginTop: '4px' }}>
                            Salora Capital Limited
                        </div>
                    </div>
                    <p style={{ marginTop: '10px' }}>
                        THIS LOAN AGREEMENT ("Agreement") is made at the place and on the date as stated in the Schedule 2 hereunder written
                    </p>

                    {/* Parties */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>BETWEEN</p>
                        <p>
                            Salora Capital Limited (hereinafter referred to as the "Salora Capital", "Salora"), a non-banking finance company ("NBFC") registered with the Reserve Bank of India ("RBI") having corporate identity number U72900MH1999PLC122849 and its registered office at A-103, Park Plaza Condominium, New Yari Road Opp. Fishery Institute, Versova, Andheri-West Mumbai City Maharashtra 400061 which shall, unless it be repugnant to the subject or context thereof, shall mean and include its successors, transferees and assigns of the First Part (hereinafter referred to as the "Lender" or "Us" or "We");
                        </p>
                        <p style={{ fontWeight: 'bold', marginTop: '20px' }}>AND</p>
                        <p>
                            The Borrower, as described in Schedule 1 (hereinafter referred to as the "Borrower", "You", "We"), which expression shall be deemed to mean and include his/her/their respective heirs, administrators, executors, legal representatives of the Second Part; AND
                            Each is hereinafter be referred to individually as 'Party' or collectively as 'Parties.' Any reference to singular includes plural.
                        </p>
                    </div>

                    {/* WHEREAS */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>WHEREAS:</p>
                        <p>
                            <strong>A.</strong> The Borrower intends to avail the loan up to an amount ("Loan") for the purposes ("Purpose") as set out in Schedule 2. D. Salora has conducted the requisite due diligence of the (" Borrowers") and credit assessment and risk profiling of the Borrower and has agreed to grant the Loan on the terms and conditions stated in this Agreement, including Schedules hereof.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>B.</strong> The loan is facilitated through the digital lending application and website "Brand Name" developed and owned by Fintech Name", a company registered under the company Act, 2013 with CIN number U74900TC078053 and having its registered at Address FIntech. is also acting as a lending service provider ("LSP") for Lender for the servicing of the loan and shall be valid and remain in in force until all amount payable, under these loan terms is repaid in full by You to Us.
                        </p>
                    </div>
                    {/* NOW THEREFORE */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold', textAlign: 'center' }}>NOW, THEREFORE, THE PARTIES HEREBY AGREE AS UNDER:</p>
                    </div>

                    {/* DEFINITIONS */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>DEFINITIONS AND INTERPRETATIONS:</p>
                        <p style={{ fontWeight: 'bold' }}>Definitions:</p>
                        <p>
                            Unless otherwise defined in this Agreement, the capitalized terms listed below shall have the following meanings: "Agreement" means this agreement and includes the schedules and annexures attached hereto and any documents included by reference. It shall include any addendum, supplemental agreements, further schedules, annexure, documents and amendments which may be made from time to time in accordance with the terms of this Agreement; "Applicable Law" and "Law" means all applicable statutes, enactments or acts of any legislative body, laws, ordinances, rules, bye-laws, regulations, notifications, guidelines, policies, directions, directives and orders of any regulatory authority, statutory authority, tribunal, board, court or recognized stock exchange governing the operations and business of the Parties and any modifications or re-enactments thereof;
                        </p>
                        <p>
                            "Associate company", as per the Company Act, is a company in which another company has a significant influence, but which is not a subsidiary company of the company having such influence and includes a joint venture company; "Borrower Dues" or "Outstanding Amount" means all sums payable by the Borrower to Salora, including outstanding loan amount, interest, and all other charges, if any, costs and expenses;
                        </p>

                        <p>
                            "Companies in the group or Group Company" shall mean an arrangement involving two or more entities related to each other through any of the following relationships: Subsidiary-parent (defined in terms of AS 21), Joint venture (defined in terms of AS 27), Associate (defined in terms of AS 23), Promoter-promotee (as provided in the SEBI (Acquisition of Shares and Takeover) Regulations, 1997) for listed companies, a related party (defined in terms of AS 18), Common brand name, and investment in equity shares of 20 percent and above.
                        </p>

                        <p>
                            "Due Date" means the date on or before which any amount is payable by the Borrower to Salora Captial.
                        </p>
                        <p>
                            "Loan" shall mean the unsecured loan availed by the Borrower from the Lender.
                        </p>
                        <p>
                            "Notices" shall have the meaning ascribed to the term in Clause 16.9(Notices);
                        </p>
                        <p>
                            "Person" means any natural person, limited or unlimited liability company, corporation, partnership (whether limited or unlimited), proprietorship, Hindu undivided family, trust, union, association, thereof or any other entity that may be treated as a person under the Applicable Law;
                        </p>
                        <p>
                            "Product" means product purchased or to be purchased by the Borrower from Vendor or/and Service Provider.
                        </p>
                        <p>
                            "RBI" means the Reserve Bank of India;
                        </p>
                        <p>
                            "Representative" means in relation to each of the Parties, its directors, officers, managers, employees and staff (including those on secondment), legal, financial and professional advisors;;
                        </p>
                        <p>
                            "Service" means services purchased or to be purchased by the Borrower from Vendor or/and Service Provider.
                        </p>
                        <p>
                            "Vendor"or Service Provider" shall means the person from whom any product and/or service is purchased and/or availed by Borrower, where the loan amount or part thereof is transferred to such vendor or service provider as specified in Schedule 2 on behalf of the Borrower.
                        </p>

                        <p style={{ fontWeight: 'bold' }}>Interpretation:</p>
                        <p>
                            In this Agreement:
                        </p>
                        <p>
                            a. Salora Capital or Salora can be used interchangeably to provide services, rights and responsibilities. b. the recitals and schedules shall constitute an integral and operative part of this Agreement;
                        </p>
                        <p>
                            c. all references to agreements, documents or other instruments include (subject to all relevant approvals) a reference to that agreement, document or instrument as amended, supplemented, substituted, novated or assigned from time to time; d. unless the context otherwise requires, the singular includes the plural and vice versa; the words 'hereof', 'herein', and 'hereto' and words of similar import when used with reference to a specific clause in, or schedule to, this Agreement shall refer to such Clause in, or schedule to, this Agreement, and when used otherwise than in connection with specific clauses or schedules, shall refer to the Agreement as a whole;
                        </p>
                        <p>
                            e. headings and the use of bold typeface shall be ignored in its construction;
                        </p>
                        <p>
                            f. words importing the singular, include the plural and vice versa;
                        </p>
                        <p>
                            g. "he," "she," or "it" is interchangeable, without gender-specific intent, and parties may request pronoun modifications for clarity, constituting reasonable cause for an amendment.
                        </p>
                    </div>

                    {/* AMOUNT OF LOAN */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>AMOUNT OF LOAN:</p>
                        <p>
                            1. Subject to and upon the terms and conditions contained herein, the Lender agrees to make the Loan available to the Borrower, and the Borrower agrees to avail the Loan from the Lender as per the terms specified in Schedule 2. The proceeds of all disbursements of the Loan shall be utilized solely for the Purpose as stated in Schedule 2.
                        </p>
                        <p>
                            2. The Borrower has requested the Lender to disburse the Loan. The disbursement of the Loan may be made to the Borrower by the Lender in a lump sum or in such instalments subject to the terms and conditions contained herein and, in any manner as mutually agreed between the Parties, including but not limited to direct disbursals towards the fulfilment of Purpose.
                        </p>
                        <p>
                            3. The Loan amount may, at the request of the Borrower, be disbursed by Salora Captial directly to the Vendor or/and Service Provider, and such disbursement shall be deemed to be disbursement to the Borrower.
                        </p>
                        <p>
                            4. The disbursement of the Loan shall be made through normal banking channels during normal banking hours. Salora Captial shall not, in any event, or circumstance whatsoever, be liable or be construed as being liable in casethere are any delays in disbursement or/and non-disbursement of the Loan on account of any technical or system errors or for any other reason.
                        </p>
                    </div>


                    {/* COVENANTS, TERMS AND CONDITIONS */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>5. COVENANTS, TERMS AND CONDITIONS:</p>
                        <p>
                            5.1 The Borrower is liable to repay the Outstanding Amount as per the repayment schedule specified in Schedule 2 and the Key Fact Statement ("KFS") made available to the Borrower, whether any demand for the same is raised by the Lender or not.
                        </p>
                        <p>
                            5.2 The Borrower shall be liable to pay respective taxes which may be applicable from time to time.
                        </p>

                        <p>
                            5.3 The Borrower shall at all times adhere to the terms and conditions set out in this Agreement and any amendments hereto. 5.4 The Borrower shall notify Salora Capital in writing of all changes in the location/address of office/residence/place of business or any change/resignation/termination/closure of employment/ profession /business.
                        </p>
                        <p>
                            5.5 The Borrower shall ensure the deposit of salary and/or business proceeds in the bank account from which the ECS/NACH/UPI mandate has been issued to Salora Capital.
                        </p>
                        <p>
                            5.6 The Borrower shall always comply with applicable laws, including the Prevention of Money Laundering Act, 2002.
                        </p>
                        <p>
                            5.7 Salora Capital shall have the right to appropriate the amounts paid by the Borrower in such manner as the Salora may, in its sole discretion, deem fit and appropriate.
                        </p>
                        <p>
                            5.9 Salora shall have the right to make disclosure of any information relating to the Borrower, including personal information, details in relation to loans, defaults, etc. to the credit information companies/Transunion CIBIL Limited (CIBIL) and/or any other governmental/regulatory/statutory or private agency/entity, credit bureau, RBI, the Lender or/and or other branches/Group/Associate companies /rating agencies, service providers, other banks/financial institutions, any third parties, any assigns/potential assignees or transferees, who may need, process and publish the information in such manner and through such medium as it may be deemed necessary by the publisher/ Lender/ RBI/ including publishing the name as part of willful defaulter's list from time to time, as also use for KYC information verification, credit risk analysis, or for other related purposes.
                        </p>

                        <p>
                            5.10 Nothing contained herein shall prejudice or adversely affect any general or special lien or right to set off to which the Lender is or may by law or otherwise be entitled or any rights or remedies of the Lender.
                        </p>

                        <p>
                            5.11 It is hereby accepted by the Parties that the amount stated by the Lender and/or Salora as due from the Borrower as maintained by the Salora Platform shall be final and conclusive proof of the correctness of any sum claimed by the Lender to be due from the Borrower in respect of this Agreement, a statement of account made out from the books of the Lender, without production of any voucher, documents or other papers whether in support thereof or otherwise and the Parties hereby agree that the same shall not be disputed by the Borrower, other than for any manifest errors therein.
                        </p>

                        <p>
                            5.12 The right of the Lender to recover the Borrower's Dues from the Borrower shall be exercised either by Lender, its authorized representatives, or any collection agency appointed for the purpose, and the Borrower hereby agrees to the same. The Borrower hereby agrees to be contacted by the collection agencies through any mode decided by the collection agency at its sole discretion and to cooperate with the collection agency to ensure repayment of the Loan.
                        </p>
                        <p>
                            5.13 The Borrower shall permit the Salora, or any other person authorize by Salora, to inspect the place of business/residence of the Borrower and agrees to produce any documents or/and additional documents as may be required by the Lender from time to time during business hours. Further, the Borrower hereby agrees to permit the Saloa and its authorized representatives to contact/meet the Borrower at their place of residence and/or employment and/or any other place for collection of dues under this Agreement.
                        </p>
                        <p>
                            5.14 Interest and all other charge shall accrue from day to day and shall be computed on the basis of the actual number of days elapsed / actual number of days in a year.
                        </p>
                        <p>
                            5.15 The Borrower agrees and undertakes that the said Loan shall be utilized exclusively for the purpose set forth in the Borrower's proposal and for no other purpose.
                        </p>

                        <p>
                            5.16 The Borrower will furnish Salora with all such information as Salora may reasonably require for its' satisfaction as due compliance with the terms of the advance and all such periodical reports and information at such times, in such form and containing such particulars as the Salora may call for, for the purpose of ascertaining the results of the utilization of the said Loan.
                        </p>

                        <p>
                            5.17 That the Borrower mutually agrees that each one or any of them are authorized and empowered by the others to appoint and acknowledge the Borrower's individual and collective liability to the Salora by any payment into the account or by way of express writing in any manner or otherwise and any such admission and acknowledgement of the liability by one or more of them shall be construed and deemed to have been made on behalf of each and all of them jointly and severally.
                        </p>
                        <p>
                            5.18 In case of Borrower being a company/firm/partnership (as the case may be) duly incorporated under the laws of India and has the power, capacity, and authority to enter into this Agreement and execute all documents related to the Loan and to exercise its rights and perform its obligations under this Agreement. Further, all action required to authorize the execution of and performance of obligations under this Agreement has been duly undertaken.
                        </p>
                        <p>
                            5.19 In case of Borrower being a company, it has not taken any corporate action nor have any other steps been taken or legal proceedings been commenced or, to the best of its knowledge and belief, threatened against the Borrower for its winding-up, dissolution, administration or re-organization or for the appointment of a receiver, administrator, administrative receiver, trustee or similar officer in respect of the Borrower or any or all of its assets or revenues.
                        </p>
                        <p>
                            5.20 In case of Borrower being a partnership firm, no disputes exist between the partners or between present partners and legal heirs of deceased partners for dissolution or accounts of the firm and no proceedings have been commenced against the Borrower or any of its partners for dissolution of the firm or appointment of a receiver or trustee in respect of all or any part of its assets or revenues.
                        </p>

                        <p>
                            5.21 The Borrower, including directors, partners or proprietors, shall not leave India for employment, business or long-term stay abroad or permanently without fully repaying all Borrower's Dues.
                        </p>

                        <p>
                            5.22General Terms: Save and except to the extent already disclosed in writing by the Borrower/s to the Salora, the Borrower/s hereby warrants and undertakes as follows:
                        </p>
                        <p>
                            a. Each Borrower is a Major and is competent in law to execute this agreement.
                        </p>
                        <p>
                            b. The Borrower is not a party to litigation of a material character, and the Borrower are not aware of any facts likely to give rise to such litigation or to material claims against the Borrower.
                        </p>
                        <p>
                            c. The Borrower has disclosed all facts relating to its income or assets to the Salora.
                        </p>
                        <p>
                            d. The Borrower agrees to furnish his income details as and when sought for by the Salora, and any change in employment or income source also shall be intimated to the Salora.
                        </p>
                    </div>


                    {/* REPAYMENT OF LOAN */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>6. REPAYMENT OF LOAN:</p>
                        <p>
                            6.1 The Borrower agrees to pay the instalment for the repayment of the Outstanding Amount, as per the Repayment Schedule set out in KFS, and shall also be liable to pay any and all overdue interest arising out of the default in repayment of instalments, any other charges, fees, etc., as per Schedule 2from time to time.
                        </p>
                        <p>
                            6.2 The Borrower hereby confirms that he has perused and understood that the interest is applied as per Schedule 2 on the principal on a daily basis and agreed to the method of computation of the instalment amount and the rate of interest as stipulated in Schedule 2.
                        </p>
                        <p>
                            6.3 The instalment amount shall automatically change upon a change in any rates, taxes, charges, levies and monies whatsoever that are or may be levied on the instalment amount or the transaction contemplated hereunder or may become payable by the Borrower by virtue of this Agreement. As stated above, such changes in the instalment amount shall be affected only prospectively, and the same shall automatically form part of the Loan.
                        </p>
                        <p>
                            6.4 The Borrower hereby confirms to have provided details of the bank account of the Borrower where all the receipts/receivables/income of the Borrower is being credited and confirms that he shall issue binding irrevocable instructions to the said bank to debit the instalment account periodically that are due to the Lender. The Borrower covenants to maintain sufficient balance in the account to enable the facilitation of debit of such amounts.
                        </p>

                        <p>
                            6.5 The Borrower hereby confirms that he will not divert his income/inflow to any other bank account till such time the dues under this agreement are paid in full.
                        </p>
                        <p>
                            6.6 The Borrower confirms having perused, understood and agreed to such mode/method of calculating the interest/instalments. 6.7 The Borrower undertakes to deliver to the Salora ENACH, NACH, or UPI mandates any other instrument acceptable to the Salora Platform towards the repayment obligations. The Borrower confirms that the aforesaid instruments are issued towards repayment of the instalment amounts, and the delivery of such instruments to the Salora shall be deemed to be an unconditional and irrevocable authority given by the Borrower to the Salora to present such instrument for repayment on their respective due dates. The Borrower confirms that such instrument shall be honoured on its first presentation, and the Borrower shall not issue any contrary instructions to the relevant bank.
                        </p>
                        <p>
                            6.8 If the Borrower wishes to modify the payment mechanism to the Lender, the Borrower may seek the permission of the Salora and, subject to the sole discretion of the Salora, may switch to another mode of payment towards discharge of liability, along with all applicable charges that may be associated with the change.
                        </p>
                        <p>
                            6.9 In the event of any delay by the Borrower in payment of any dues under this Agreement, whether by way of repayment of Loan, payment of interest or other charges payable hereunder, the Salora reserves the right to charge additional charges as described in the Schedule 2 on the amount in arrears, from the due date of such payment till the date of realization of payment as the case may be.
                        </p>
                    </div>


                    {/* COOLING-OFF PERIOD */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>7. COOLING-OFF PERIOD:</p>
                        <p>
                            The Borrower shall have the option to exit the Loan by paying the principal and the proportionate APR ("Annual Percentage Rate") without any penalty during the Cooling-off Period. The Borrower continuing with the Loan after the Cooling-off Period shall be required to pay the charges and fees as per KFS. The Borrower is entitled to a cooling off period of 3 days during which the Borrower can decide whether they want to continue with the Loan or not ("Cooling Off Period").
                        </p>
                    </div>

                    {/* PRE-PAYMENT OF LOAN */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>8. PRE-PAYMENT OF LOAN:</p>
                        <p>
                            8.1 Salora Capital may, at its discretion, accept the full pre-payment of the Outstanding Dues and foreclose the Loan if the Borrower has paid the instalment as per schedule 2.
                        </p>
                        <p>
                            8.2 The Borrower acknowledges that the flexibility in the repayment schedule for advancing the repayment shall be subject to the Flexible Repayment Convenience Charges as specified by KFS.
                        </p>
                        <p>
                            8.3 The amount pre-paid shall be first used to credit the overdue interest, bank charges, legal expenses, if any, arrears of instalments, interest due up to date for the current month, the current month instalment, Flexible Repayment Convenience Charges and other expenses due as mentioned in this Agreement. If any amount remains unadjusted after meeting the aforesaid charges/amounts, then it shall be adjusted towards the outstanding principal amount. If the entire amount due for prepayment is not remitted, then the amount so received by the Salora Capital would be treated as an advance payment of future instalment and will be adjusted to instalment month on month, as and when the instalment falls due for payment. The Borrower hereby agrees that the Salora Capital is not obliged to reverse the interest that may accrue on account of advance payment. The amount due under foreclosure should be paid in full by the Borrower in the Escrow Account maintained by the Salora Capital to qualify the account for foreclosure.
                        </p>
                        <p>
                            8.4 The Borrower confirms that none of such instruments is a security and shall not be treated as such in the event of any dispute. 8.5 The Borrower authorizes the Salora Capital to deduct the amount under the Loan from the POS payments/QR Transactions of the Borrower/other payments collected from the Borrower for the repayment of the Borrower Dues.
                        </p>
                        <p>
                            8.6 Any dispute or difference of any nature whatsoever shall not entitle the Borrower to withhold or delay payment of any instalment amount or another sum.
                        </p>
                    </div>


                    {/* FEES, COSTS AND EXPENSES */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>9. FEES, COSTS AND EXPENSES:</p>
                        <p>
                            9.1 The Borrower hereby agrees to pay Salora Capital the fees in the quantum and manner set out in Schedule 2 of this Agreement. The Borrower hereby authorize the Salora Capital to deduct these amounts together from the Loan Amount and pay to the Borrower/Vendor/Service provider, as the case may be, only the balance amount. The Borrower hereby confirms that irrespective of deduction of such fees, the Borrower's obligation to repay to the Lender shall be of the entire Loan Amount along with interest and other charges in terms of this Agreement. The fees paid to/deducted by the Lender are non-refundable/ non-adjustable.
                        </p>
                        <p>
                            9.2 The Borrower shall also pay all third-party costs and expenses on an actual basis, including legal expenses, incurred in connection with the processing, negotiation, documentation, and placement of the Loan, whether or not the disbursement occurs. In addition, the Borrower shall also be responsible for all charges as well as any and all registration charges in relation to the execution and delivery of the agreement and related transaction documents. The Borrower shall pay all costs, charges, and expenses incurred by the Salora Capital, including travelling and other allowances of their officers, on solicitors/ advocates/ company secretaries employed by them, for protection and preservation of rights/remedies arising out of the agreement and related documents.
                        </p>
                    </div>

                    {/* SECURITY */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>10. SECURITY:</p>
                        <p>
                            The Loan is unsecured, and no security has been provided by the Borrower to the Lender to secure his/their repayment/ payment obligations in terms of this Agreement.
                        </p>
                    </div>


                    {/* EVENTS OF DEFAULT AND CONSEQUENCES */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>11. EVENTS OF DEFAULT AND CONSEQUENCES:</p>
                        <p>
                            11.1 The following shall amount to an Event of Default:
                        </p>
                        <p>
                            a) Non-compliance/breach by the Borrower of any of the terms and conditions of this Agreement, any other document entered into in respect of this Loan, or any other financial assistance availed of by the Borrower under this agreement.;
                        </p>
                        <p>
                            b) Non-adherence to the repayment schedule;
                        </p>
                        <p>
                            c) Any filing for insolvency, bankruptcy, winding up, dissolution of the Borrower or inability of the Borrower to repay his debts;
                        </p>
                        <p>
                            d) Concealment of any material document, information or event by the Borrower;
                        </p>
                        <p>
                            e) Submission of any forged document or any misrepresentation by the Borrower;
                        </p>
                        <p>
                            f) Death, mental incapacity or other disability of the Borrower;
                        </p>
                        <p>
                            g) If any representation, warranty or statement on the part of the Borrower of any credit information is or is found to be incorrect or misleading (whether by reason of omission to state a material fact or otherwise);
                        </p>
                        <p>
                            h) If Borrower fails to furnish the papers or documents required by Salora Capital or fails to furnish the information called for by the Salora Capital from time to time;
                        </p>
                        <p>
                            i) If any of the representations, undertakings and/or declarations made in this Agreement and/or Loan application are found to be false or incorrect or not complied with;
                        </p>
                        <p>
                            j) The Borrower utilizes the Loan for any purpose other than the Purpose mentioned in Schedule 2;
                        </p>
                        <p>
                            k) Occurrence of any events, conditions or circumstances (including any change in law) which, in the sole and absolute opinion of the Salora Capital, could have a material adverse effect, including limitation of any proceedings or action for bankruptcy/liquidation/ insolvency of the Borrower or attachment/restraint of any of Borrower's assets;
                        </p>

                        <p>
                            l) Any other event which is the sole opinion/discretion of the Salora Capital, would endanger the repayment of the Loan. m) Any default by the Borrower under any other agreement or arrangement or other indebtedness of the Borrower with the Salora Capital or its group/associate companies shall constitute an event of default under this Agreement and vice-versa. n) The decision of the Salora Capital as to whether or not an Event of Default has occurred shall be final and binding on the Borrower.
                        </p>
                        <p>
                            11.2 If there is an Event of Default, the following consequences may be applicable to the Borrower, at the discretion of the Salora Capital notwithstanding any and all remedies that the Lender may have in law: a) shall have the right to recall the entire Outstanding Amount, as mentioned in Schedule 2 hereunder, and the same shall accordingly become immediately due and payable.
                        </p>
                        <p>
                            b) shall be entitled to proceed against and take any action against the Borrower in order to realize the amounts due and payable by the Borrower, whether with or without the intervention of the Courts.
                        </p>
                        <p>
                            c) shall be entitled to initiate criminal proceedings or any other appropriate actions against the Borrower if at any time the Lender, at its sole discretion, has sufficient grounds to believe that the Borrower has made any misrepresentations and/or submitted any forged documents or fabricated data.
                        </p>
                        <p>
                            d) shall have rights and powers conferred on the Lender under this Agreement shall be in addition and supplemental to any rights the Lender has as a creditor against the Borrower under any law for the time being in force and shall not be in derogation thereof.
                        </p>
                        <p>
                            e) shall have a paramount right of set-off, and in the exercise of the Salora Capital's general lien under law, the Salora Capital shall also have a paramount right of lien on all monies, accounts, securities, deposits, goods and other assets and properties belonging to the Borrower or standing to the Borrower's credit (whether singly or jointly with other person/s) which are or may at any time with or in possession or control of any group/associate companies of the Salora Capital for any reason or purpose whatsoever.
                        </p>
                        <p>
                            f) The Borrower shall bear all legal and other costs and expenses resulting from the foregoing defaults or the exercise of any remedies by Salora Capital.
                        </p>
                    </div>

                    {/* REPRESENTATIONS & WARRANTIES OF THE BORROWER */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>12. REPRESENTATIONS & WARRANTIES OF THE BORROWER:</p>
                        <p>
                            12.1 The Borrower represents and warrants that:
                        </p>
                        <p>
                            12.1.1 the execution, delivery, and performance of this Agreement are within his powers, do not contravene any contract binding on or affecting his or any of his properties, and do not violate any applicable law or regulations; 12.1.2 this Agreement is valid and binding upon the Borrower;
                        </p>
                        <p>
                            12.1.3 there is no pending or threatened action which may materially adversely affect the validity or enforceability of this Agreement;
                        </p>
                        <p>
                            12.1.4 is not prohibited by any law or order of any court/forum from entering into this Agreement and performing all obligations.
                        </p>
                        <p>
                            12.1.5 No event has occurred which affects/shall prejudicially affect the interest of Salora or affect the financial conditions of Borrower or its ability to perform all obligations.
                        </p>
                        <p>
                            12.1.6 The Borrower is not in default of payment of any taxes or government dues.
                        </p>
                        <p>
                            12.1.7 The Borrower will do all other acts, deeds and things, as required by Salora, to further protect the interests of Salora and Lenders.
                        </p>
                        <p>
                            12.1.8 No bankruptcy or insolvency proceedings are pending in respect of the Borrower.
                        </p>
                        <p>
                            12.1.9 The Borrower expressly consents to Salora to collect, disclose, store and share the information provided by the Borrower or otherwise procured by Salora in such manner if it deems fit.
                        </p>

                        <p>
                            12.1.10 The Borrower will not seek to claim or recover from the Lender and/or Salora, on any grounds whatsoever and/or in any circumstances whatsoever(whether now or hereafter existing), any purported damages or compensation, direct, indirect or consequential, for any acts or actions whatsoever of the Lender and/or Salora hereunder and/or in respect of the Loan, taken or omitted by the Lender and/or Salora in terms hereof and/or pursuant hereto and/or to protect any of its interests and rights as the lender or a creditor or a service provider, and the Borrower hereby expressly waives any right to seek or make any such claim or recovery on any grounds whatsoever.
                        </p>
                        <p>
                            12.1.11 The Borrower shall bear all costs and other expenses incurred in relation to the Loan and in complying with the terms and conditions in respect thereof, including any and all costs incurred in connection with this Agreement. 12.1.12 The Borrower hereby confirms his liability and shall reimburse or pay any applicable tax that the Lender /Salora may have to pay to the government regarding the Loan.
                        </p>
                        <p>
                            12.1.13 The Borrower hereby authorizes the Lender and/or Salora, at the cost and risk of the Borrower, to engage one or more persons and/or agencies to verify any fact or information furnished by, concerning and pertaining to the Borrower and collect the outstanding amount and may furnish to such persons such documents, information, facts and figures as it may deem fit.
                        </p>
                        <p>
                            12.1.14 Any claims, demands, actions, costs, expenses and liabilities incurred or suffered by the Lender and/or Salora by reason of non-payment or insufficient payment of stamp duty on this Agreement and any documents and other writings which may be executed by the Borrower pursuant to or in relation to the Loan, will be to the cost of the Borrower.
                        </p>
                        <p>
                            12.1.15 The Borrower expressly consents to Salora to download their data from the Central KYC Registry ("CKYCR") for the purpose of Know Your Customer ("KYC") verification and compliance with regulatory requirements.
                        </p>
                        <p>
                            12.1.16 The Borrower expressly give consent to Salora to share and disclose the Borrower's information with third parties only for the purpose of the Loan on a need-to-know basis.
                        </p>

                        <p>
                            12.1.17 All information provided by the Borrower to the Salora or its authorized representative under or with respect to this Agreement is correct and true and is not misleading in any respect.
                        </p>
                        <p>
                            12.1.18 The execution and performance of this Agreement by the Borrower constitutes, and the exercise by the Borrower of his rights and performance of his obligations hereunder shall constitute private and commercial acts done and performed for private and commercial purposes. The Borrower will not seek to claim or recover from the Lender and/or Salora, on any grounds whatsoever and/or in any circumstances whatsoever (whether now or hereafter existing), any purported damages or compensation, direct, indirect or consequential, for any acts or actions whatsoever of the Lender and/or Salora hereunder and/or in respect of the Loan, taken or omitted by the Lender and /or Salora in terms hereof and/or pursuant hereto and/or to protect any of its interests and rights as the Lender or a creditor or a Service Provider, and the Borrower hereby expressly waives any right to seek or make any such claim or recovery on any grounds whatsoever.
                        </p>
                        <p>
                            12.1.19 The Borrower hereby accepts and confirms that it has no objection to the Lender administering the Loan through third Parties, including Salora. The Borrower confirms that the Lender may, either partly or in full, delegate such activities to any third party (including Salora) as it may think fit in the circumstances. Such delegation of work would include the right and authority to collect the outstanding on behalf of the Lender, the dues and unpaid instalments and other amounts due from the Borrower and to perform and execute all lawful acts, deeds and matters and things connected therewith and incidental thereto including sending notices to the Borrower, receiving cash against the issue of the receipt, cheques, and drafts. For the purpose aforesaid as also for any other purposes, at the sole discretion of the Lender and/or Salora, the Lender and/or Salora shall be entitled to disclose to the third party the details of the Borrower, Loan and the Outstanding Amount and any other information for effectively discharging the work assigned to the third Party and the Borrower hereby consents to such disclosure by the Lender. Notwithstanding any such delegation by the Lender and/or Salora, neither the Lender nor Salora shall be responsible and/or liable for any unlawful acts, deeds, matters and things done by such third parties.
                        </p>

                        <p>
                            12.1.20 The Borrower hereby authorizes Lender and/or Salora, at the cost and risk of the Borrower, to engage one or more person and/or agencies to verify any fact or information furnished by, concerning and pertaining to the Borrower and collect the outstanding amount and may furnish to such person/s such documents, information, facts and figures as it may deem fit.
                        </p>
                        <p>
                            12.1.21 Changes to the Loan amount or partial loan cancellation: In case of partial cancellation of the Loan by the Borrower or any other changes to the Loan amount, Salora may formulate a new repayment schedule based on the new amount and charges applicable thereof. Where the Repayment Schedule is amended as herein, Salora shall update the instruments provided by the Borrower for repayment under Clause 6 of this agreement along with amounts and dates thereof.
                        </p>
                        <p>
                            12.2 In the event the Loan is for the purchase of any Product and/ Services, the Borrower also undertakes and covenants as below: 12.2.1 The Vendor/Service Provider shall be exclusively responsible for the delivery of the Product and/ Services to the Borrower and Salora shall not be liable for any delay in delivery or non-delivery other Products and/ Services and/or with respect to the quality, condition, fitness, suitability or otherwise whatsoever of the Product.
                        </p>
                        <p>
                            12.2.2 In the case of cancellation of order for the Product and/ Services, Salora will treat the relevant Loan repaid only if the Vendor/Service Provider refunds the amount directly to Salora upon compliance by the Borrower with the refund policy of the Vendor/Service Provider. In case of such refund, Salora shall refund the monies if any, paid by the Borrower, less interest and other charges if any for the period between the date of the loan disbursement and refund, and treat the Loan at Salora Capital option as fully discharged. The processing charges will not be reimbursed and will be adjusted against the refund, if any.
                        </p>

                        <p>
                            12.2.3 The Borrower will not give part possession or ownership of the product or service or create any third-party rights thereon without the consent of Salora.
                        </p>
                        <p>
                            12.2.4 The Borrower shall not use the Product and/or Services for unlawful or antisocial purposes and will use the same only for its own use and not for resale, barter exchange or the like.
                        </p>
                        <p>
                            12.2.5 The Borrower shall not be entitled to any increase in the Loan amount by reason of any increase in the purchase price. However, in the event of any decrease in the purchase price, Salora may, at its discretion, reduce the principal amount of the loan.
                        </p>
                        <p>
                            12.2.6 The Borrower shall not use or permit the use of Product for any purpose not permitted by the insurance policy's terms, if any, or warranty and not do or permit to be done any act or thing which might render the insurance or warranty invalid.
                        </p>
                        <p>
                            12.2.7 In the instance Vendor/Service Providers or the Borrower reschedules the service towards which the Loan has been disbursed, the Borrower shall immediately inform the Salora of such rescheduling.
                        </p>
                    </div>

                    {/* UNDERTAKINGS BY THE BORROWER */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>13. UNDERTAKINGS BY THE BORROWER:</p>
                        <p>
                            13.1 The Borrower undertake and agrees with the Salora Capital throughout the term of this Agreement He shall:
                        </p>
                        <p>
                            13.1.1 apply for a Loan through Salora Capital as stated in this Agreement.
                        </p>
                        <p>
                            13.1.2 declare that all the particulars, information and details provided in this agreement and the documents submitted are true, correct, complete and up-to-date in all respects and
                        </p>
                        <p>
                            13.1.3 be competent to contract and that no insolvency proceedings or suits for recovery of outstanding dues, monies, or property(ies) and/or any criminal proceedings have been initiated and/or are pending.
                        </p>
                        <p>
                            13.1.4 agreeing to initiate the process for availing the Loan through Salora Capital,
                        </p>
                        <p>
                            13.1.5 explicitly provide his consent to Salora Capital to access his credit information from the relevant agencies/authorities.
                        </p>
                        <p>
                            13.1.6 hereby consent to and authorize Salora Capital to increase or decrease the credit limit assigned to him from time to time. He shall not raise any objection or dispute with regard to the same at any point of time.
                        </p>
                        <p>
                            13.1.7 agrees to limit his obligations to a maximum of INR 10 lakhs across all peer-to-peer platforms within India. 13.1.8 understand that his Salora Capital account login credentials, including login and transaction password issued by Salora Capital from time to time, constitute confidential information;
                        </p>
                        <p>
                            13.1.9 agree to keep the same secure and confidential to prevent any authorize use / misuse.
                        </p>
                        <p>
                            13.1.10 expressly authorizes Salora Capital to send him communications regarding Loans, insurance and other products from Salora Capital, its group companies and/or third parties through telephone calls/ SMSs /emails/post or any other mode including but not limited to promotional communications.
                        </p>

                        <p>
                            13.1.11 provide a valid email address and contact telephone and/ or mobile number to Salora Capital for the purpose. 13.1.12 confirm that receipt of such communications shall not be treated by him as unsolicited communication, as defined under TRAI Regulations on Unsolicited Commercial Communications.
                        </p>
                        <p>
                            13.1.13 hereby consent and authorize Salora Capital to send notifications and updates regarding his Loan using WhatsApp.
                        </p>
                        <p>
                            13.1.14 acknowledge and confirm that the Loans may be disbursed into the third party's bank account (Vendor and/or Service Provider) as per the instructions provided by him in the disbursement request.
                        </p>
                        <p>
                            13.1.15 agree to provide specific consent for the Online Know Your Customer process, specifically the authentication through One-Time Password. (OTP).
                        </p>
                        <p>
                            13.1.16 declare and undertake that neither he has opened, nor will he open, any other account using OTP-based KYC in a non-face-to-face mode with any other regulated entity ("RE")furthermore, He acknowledges and understands that while uploading his KYC information to the Central KYC Registry (CKYCR), the RE facilitating this process shall explicitly indicate that the account has been opened using OTP-based e-KYC, and he shall commit to the understanding that other REs shall not open accounts based on the KYC information provided for accounts opened using the OTP-based e-KYC procedure in a non-face-to-face mode.
                        </p>
                        <p>
                            13.1.17 declare that any additional information deemed necessary beyond the specifications outlined in the internal KYC Policy of Salora Capital will be obtained with his explicit consent, as required.
                        </p>
                        <p>
                            13.1.18 understands and agrees that this additional information may be collected to enhance the due diligence process and compliance efforts of the Salora.
                        </p>

                        <p>
                            13.1.19 agree that there is no impediment or restriction (whether legal or judicial) against him and/or his asset filed/ reported by any other bank/financer.
                        </p>
                        <p>
                            13.1.20 agree that he has read the entire Agreement, including the Loan details and the terms of repayment, the fees, costs, charges, and expenses payable as clearly enumerated in Schedule 2 to this Agreement or as communicated separately to the Borrower. The Borrower further confirms that the entire Agreement is filled in their presence and that the contents provided herein are explained in the language understood by the Borrower. The Borrower further confirms having executed the Agreement and agrees to remit the dues in terms of Schedules hereunder.
                        </p>
                    </div>

                    {/* INDEMNIFICATION */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>14. INDEMNIFICATION:</p>
                        <p>
                            14.1 The Borrower shall indemnify and hold harmless Salora Capital, along with its directors, officers, employees, agents, and advisers, against any losses, claims, liabilities, or damages arising from any acts, errors, or omissions by the Borrower, its agents, or assignees, or from improper performance or non-performance related to the Loan, this Agreement, or any other document executed in connection with this Agreement.
                        </p>
                        <p>
                            14.2 The Borrower hereby agrees to indemnify, the Salora Capital and their officers, representatives and agents against any loss or expenses sustained or incurred by them as a result of:
                        </p>
                        <p>
                            14.2.1 the Borrower failing to take necessary action to protect the Salora Capital's interests;
                        </p>

                        <p>
                            14.2.2 default on the part of the Borrower in complying with the provisions of any Agreement or related documents; 14.2.3 the occurrence of any Event of Default;
                        </p>
                        <p>
                            14.2.4 any delay in payment of any sums payable or reimbursable by the Borrower under or pursuant to any agreement or related documents;
                        </p>
                        <p>
                            14.2.5 levy by any Government authority of any charge, tax, penalty, or any other amount in connection with regularizing or perfecting any of the agreement or related documents as may be required under law at any time during the currency of the Loan or getting any of the documents admitted into evidence, or relying on any transaction document for proving any claim;
                        </p>
                        <p>
                            14.2.6 The exercise of any rights by Salora Capital under this Agreement or any related document shall be at its sole discretion and shall not require prior notice to or consent from the Borrower.
                        </p>
                    </div>


                    {/* TERM AND TERMINATION */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>15. TERM AND TERMINATION:</p>
                        <p>
                            15.1 This Agreement shall become effective on execution and shall stand terminated on the date the Borrower has repaid the Loan in full along with interest, bank charges and any other costs, charges and expenses as mentioned herein and fulfilled all other obligations under the Agreement to the satisfaction of the Salora Capital.
                        </p>
                        <p>
                            15.2 The Borrower does not have the right to terminate this Agreement in any situation except with the written consent of the Salora Capital by repaying the entire amounts due under this Agreement.
                        </p>
                    </div>

                    {/* MISCELLANEOUS */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>16. MISCELLANEOUS:</p>
                        <p>
                            16.1 Assignment: It is expressly agreed that the Borrower shall not assign, either directly or indirectly, any of the rights or obligations set forth in this Agreement. However, Salora Capital is entitled to assign its rights and obligations under this Agreement, in whole or in part, to any third party. Salora Capital may, at any time and without reference to the Borrower, sell, assign, or transfer its rights and obligations under this Agreement in any manner it deems appropriate. The Borrower acknowledges and agrees that any such sale, assignment, or transfer shall be binding upon them conclusively.
                        </p>
                        <p>
                            16.2 Waiver: Any omission or delay on the part of Salora Capital in exercising any of its rights, powers or remedy, upon failure by the Borrower in the due and punctual fulfilment of the obligations of the Borrower hereunder shall not be deemed to constitute a waiver by Salora Capital of any of its rights to require such due, punctual and full performance by the Borrower.
                        </p>
                        <p>
                            16.3 Severability: If any provision in this Agreement shall be found or be held to be invalid or unenforceable, then the meaning of said provision shall be construed, to the extent feasible, so as to render the provision enforceable, and, if no feasible interpretation would save such provision, it shall be severed from the remainder of this Agreement and in such an event, the Parties shall use best efforts to negotiate, in good faith, a substitute, valid and enforceable provision or agreement, which most nearly reflects the Parties' intent in entering into this Agreement.
                        </p>
                        <p>
                            16.4 Authorization: The persons signing this Agreement on behalf of the Parties represent and covenant that they have the requisite authority to so sign and execute this Agreement on behalf of the Parties for whom they are signing.
                        </p>

                        <p>
                            16.5 Variation: No variation of this Agreement shall be valid unless it is in writing (which, for this purpose, also includes email) and signed by or on behalf of each of the Parties. The expression 'variation' includes any variation, amendments, supplement, deletion or replacement however effected. In case of any variation through email, the variation shall be deemed to have been accepted by the Borrower if so, communicated by the email provided by the Borrower for availing the Loan.
                        </p>
                        <p>
                            16.6 Entire Agreement: This Agreement, together with the documents executed/exchanged by the Parties in relation to the Loan, supersede all prior discussions and agreements (whether oral or written, including all correspondence) between the Parties with respect to, or in relation to the Loan, and this Agreement, along with the Schedules hereto, together with the documents executed/exchanged by the Parties in relation to the Loan, contains the sole and entire agreement between the Parties with respect to the Loan.
                        </p>
                        <p>
                            16.7 Governing Law & Arbitration:
                        </p>
                        <p>
                            a. This Agreement shall be governed and construed in accordance with the substantive laws of India, and the Parties hereto submit to the exclusive jurisdiction of the Courts situated at Gurugram, Haryana. The Parties irrevocably waive any objection, now or in the future, to laying the venue of any proceedings in the courts and tribunals at Haryana.
                        </p>
                        <p>
                            b. Nothing contained in this Clause 16.7 shall limit any right of the Lender and/or Salora to take proceedings (including criminal proceedings under the Payment and Settlement Systems Act 2007 or Negotiable Instruments Act, 1881) in any other court or tribunal of competent jurisdiction, nor shall the taking of proceedings in one or more jurisdictions preclude the taking of proceedings in any other jurisdiction whether concurrently or not and the Parties irrevocably submit to and accept for themselves and in respect of their property, generally and unconditionally, the jurisdiction of such court or tribunal, and the Parties irrevocably waive any objection they may have now or in the future to the laying of the venue of any proceedings and any claim that any such proceedings have been brought in an inconvenient forum.
                        </p>

                        <p>
                            c. Any disputes, differences, controversies and questions directly or indirectly arising at any time hereafter between the Parties or their respective representatives or assigns, arising out of or in connection with this Agreement (or the subject matter of this Agreement), including, without limitation, any question regarding its existence, validity, interpretation, construction, performance, enforcement, rights and liabilities of the Parties, or termination ("Dispute"), shall be referred to a sole arbitrator duly appointed by Parties. The seat and venue of the arbitration shall be in Gurugram, and the language of proceedings shall be in English. The award rendered shall be in writing and shall set out the reasons for the arbitrator's decision. The costs and expenses of the arbitration shall be borne equally by each Party, with each Party paying for its fees and costs, including attorney fees, except as may be determined by the arbitration tribunal. Any award by the arbitration tribunal shall be final and binding.
                        </p>
                        <p>
                            16.8 Specific Performance: The Parties agree that damages may not be an adequate remedy, and the Parties shall be entitled to seek an injunction, restraining order, right for recovery, suit for specific performance, or such other equitable relief as a court of competent jurisdiction may deem necessary or appropriate to restrain the other Parties from committing any violation or enforce the performance of the covenants and obligations contained in this Agreement. These injunctive remedies are cumulative and are in addition to any other rights and remedies the Parties may have at law or in equity.
                        </p>
                        <p>
                            16.9 Notices: Every notice, request, demand or other communication under this Agreement shall:
                        </p>
                        <p>
                            a. be in writing, delivered by hand, or by registered post/speed post, acknowledgement due, or by courier or any other mode as decided by the Salora;
                        </p>
                        <p>
                            b. be deemed to have been received by the Borrower when delivered by hand, at the time so delivered, and if given by registered post acknowledgement due 72 hours after it has been put into the post;
                        </p>

                        <p>
                            c. be sent to the Borrower to the address mentioned in Schedule 1 hereto or to such other address as either Party may notify the other Party in writing hereafter.
                        </p>
                        <p>
                            d. Be sent to the Salora:
                        </p>
                        <p>
                            e. The Borrower hereby agrees to pay the postal and other charges as mentioned in Schedule 2 here for each of the notices being sent to him.
                        </p>
                    </div>

                    {/* DISCLOSURE OF INFORMATION */}
                    <div style={{ marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>17. DISCLOSURE OF INFORMATION:</p>
                        <p>
                            17.1 The Borrower acknowledges, agrees, and consents to Salora's right to disclose and share any and all information and data pertaining to the Borrower, including but not limited to details of the facilities availed, transactions conducted with Salora, the Borrower's account, and any agreements and documents related to the Loans and transactions. This includes information regarding any defaults by the Borrower in fulfilling their obligations related to the Loan or other transactions.Salora may disclose such information as it deems necessary and appropriate to the Reserve Bank of India (RBI), credit information companies, any other relevant agency or body, and potential assignees, professional advisers, consultants, and service providers engaged by Salora in connection with the Loan. Additionally, this information may be shared with the Borrower's acquaintances, as required by law or any applicable regulations, or upon the order or request of a court of law, or any statutory, regulatory, or supervisory authority A-103, Park Plaza Condominium, New Yari Road Opp. Fishery Institute, Versova, Andheri-West Mumbai City Maharashtra 400061.
                        </p>
                        <p>
                            17.2 The Borrower undertakes and agrees to provide all requested information, including details of any other credit facilities currently held by the Borrower, as and when required by Salora. The Borrower further declares that all information furnished to Salora from time to time is and will remain true, accurate, and complete.
                        </p>
                        <p>
                            17.3 The Borrower hereby further agrees that in case the Borrower fails to pay the dues herein or commits default in the repayment of the Loan instalments or interest thereon on the due date(s), or the account of the Borrower becomes non-performing assets as per the RBI's norms, the Salora will be at liberty to disclose or publish in print and/or electronic media the photograph(s), name(s) and address(es) of the Borrower as willful defaulter along with the details of outstanding dues payable.
                        </p>
                        <p>
                            17.4 The Borrower acknowledges and accepts that the Reserve Bank of India (RBI), Credit Information Companies, or any other authorized agency, as well as any statutory, regulatory, or supervisory authority, may use, process, and disseminate the information and data disclosed by Salora in any manner they deem appropriate. The Borrower further agrees that Salora shall not be held responsible or liable for any such use, processing, or dissemination of the information.
                        </p>
                        <p>
                            17.5 The Salora may disclose to the Borrower all such information relating to the Loan, as may be reasonably requested by it, in accordance with the applicable laws.
                        </p>
                    </div>


                    {/* Signatures */}
                    {/* <div style={{ marginTop: '50px', marginBottom: '30px' }}>
                        <div style={{ float: 'left', width: '50%', textAlign: 'center' }}>
                            <p>Signed, Sealed and delivered,</p>
                            <p>Salora Capital Limited</p>
                            <div style={{ width: '150px', height: '1px', backgroundColor: '#000', margin: '20px auto' }}></div>
                            <p>Amit Kumar</p>
                            <p>Director</p>
                            <p>Date: {agreement?.approval?.approvedDate || agreement?.eSign?.esignDate || new Date().toLocaleDateString()}</p>
                        </div>
                        <div style={{ float: 'right', width: '50%', textAlign: 'center' }}>
                            <p>Signed, sealed and delivered on behalf of the within named</p>
                            <p>Borrower Name: {agreement?.customer?.borrowerName || applicationId || ''}</p>
                            <div style={{ width: '150px', height: '1px', backgroundColor: '#000', margin: '20px auto' }}></div>
                            <p>Date: {agreement?.approval?.disbursedDate || agreement?.lead?.createDate || ''}</p>
                            <p>Digitally accepted By: {esignData.digitallyAcceptedBy || agreement?.eSign?.name || ''}</p>
                        </div>
                        <div style={{ clear: 'both' }}></div>
                    </div> */}

                    {/* Consent Mode */}
                    <div style={{ marginTop: '50px', marginBottom: '30px' }}>
                        <p style={{ fontWeight: 'bold' }}>Consent Mode</p>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>OTP Sent To</th>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>OTP Entered On App At</th>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>Device Used</th>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>IP Address</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{esignData.otpSentTo || (otpSent ? 'Sent' : '')}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{esignData.otpEnteredOnAppAt || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{esignData.deviceUsed || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{esignData.ipAddress || ''}</td>
                                </tr>
                            </tbody>
                        </table>

                        {esignData.digitallyAcceptedBy && (
                            <div style={{ marginTop: '20px' }}>
                                <p>Digitally accepted By: {esignData.digitallyAcceptedBy}</p>
                            </div>
                        )}
                    </div>


                    {/* SCHEDULE 1 */}
                    <div style={{ marginTop: '50px', marginBottom: '30px', pageBreakBefore: 'always' }}>
                        <h3 style={{ textAlign: 'center' }}>DESCRIPTION OF THE BORROWER</h3>
                        <h4 style={{ textAlign: 'center' }}>SCHEUDLE 1</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>Description</th>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>Particulars</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Name</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.borrowerName || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Co applicant name</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>NA</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Aadhar Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.aadhaarNumber || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>PAN Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.panNumber || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Mobile Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.mobileNumber || agreement?.eSign?.phoneNumber || ''}</td>
                                </tr>
                                {/* <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Alternate Mobile Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>828XXX</td>
                                </tr> */}
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Email Address</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.email || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Residential Address</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.address || agreement?.address?.address || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Office Address</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>NA</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* SCHEDULE 2 */}
                    <div style={{ marginTop: '50px', marginBottom: '30px', pageBreakBefore: 'always' }}>
                        <h3 style={{ textAlign: 'center' }}>TERMS OF THE LOAN</h3>
                        <h4 style={{ textAlign: 'center' }}>SCHEDULE 2</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>Description</th>
                                    <th style={{ border: '1px solid #000', padding: '5px' }}>Particulars</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Application Id</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.lead?.applicationId || agreement?.approval?.loanId || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Date of Execution</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.approvedDate || agreement?.eSign?.esignDate || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Place of Execution</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{'Gurgaon'}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Purpose of Loan</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.lead?.productName || agreement?.approval?.productName || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Sanction Amount</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.loanAmount || agreement?.lead?.loanAmount || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Tenure</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.tenure || agreement?.lead?.tenure || ''} Days</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Rate of Interest ({mapRepaymentTypePA(agreement?.approval?.repaymentType || agreement?.lead?.repaymentType)})</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{(agreement?.approval?.roi || agreement?.lead?.roi || '') / mapRoi(agreement?.approval?.repaymentType || agreement?.lead?.repaymentType)}%</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>APR</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{resolveApr(agreement?.approval, agreement?.lead)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Installment Amount</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>₹{getInstallmentAmount()}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Installment Start Date</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{getInstallmentStartDate()}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Repayment Frequency</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{mapRepaymentType(agreement?.approval?.repaymentType || agreement?.lead?.repaymentType)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Vendor /Service Provider</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.partnerName || 'NA'}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Lending Service Provider</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.fintech?.name || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Repayment Schedule</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>As per KFS</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Disbursement Account</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.bankDetails?.accountNumber || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Processing Charges</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.processingFee || agreement?.lead?.processingFee || ''}%</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Flexible Repayment Convenience Charges</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>NA</td>
                                </tr>
                                {/* <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Penal Charges</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}></td>
                                </tr> */}
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Insurance Charges</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>NA</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Payment Bounce Charges</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>INR as Per KFS</td>
                                </tr>
                            </tbody>

                        </table>

                         <div className='penal mb-3'>Penal Interest</div>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                border: "1px solid #000",
                                marginTop: "30px"
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #000", padding: "10px", backgroundColor: "#f2f2f2", textAlign: "center" }}>
                                    ID
                                    </th>
                                    <th style={{ border: "1px solid #000", padding: "10px", backgroundColor: "#f2f2f2", textAlign: "center" }}>
                                    OverDue Range (INR)
                                    </th>
                                    <th style={{ border: "1px solid #000", padding: "10px", backgroundColor: "#f2f2f2", textAlign: "center" }}>
                                    Penal Interest (INR)
                                    </th>
                                </tr>
                            </thead>
                           
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>1</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>0.0 - 100.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>5.0</td>
                                </tr>

                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>2</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>101.0 - 1000.0 </td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>25.0</td>
                                </tr>

                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>3</td>
                                   <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>1001.0-2500.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>75.0</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>4</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>2501.0 - 5000.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>100.0</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>5</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>5001.0 - 7500.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>125.0</td>
                                    
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>6</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>7501.0 - 12500.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>150.0</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>7</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>12501.0 - 20000.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>175.0</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>8</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>20001.0 - 30000.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>200.0</td>

                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>9</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>30001.0 - 40000.0</td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>225.0</td>

                                </tr>
                            </tbody>
                        </table>



                    </div>


                    {/* LOAN APPLICATION */}
                    <div style={{ marginTop: '50px', marginBottom: '30px', pageBreakBefore: 'always' }}>
                        <h3 style={{ textAlign: 'center' }}>Applied Loan Amount: LOAN APPLICATION</h3>
                        <h4 style={{ marginTop: '20px' }}>PERSONAL DETAILS:</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Name</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.borrowerName || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Date of Birth</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.dob || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Marital Status</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{mapMarital(agreement?.customer?.maritalStatus) || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Gender</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{mapGender(agreement?.customer?.gender)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Pan Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.panNumber || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Aadhar Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.aadhaarNumber || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Net Monthly income</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.professionalDetail?.salary || agreement?.professionalDetail?.annualIncome || ''}</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4 style={{ marginTop: '20px' }}>CONTACT DETAILS:</h4>
                        <table className="table-responsive" style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Residence is</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.address || agreement?.address?.address || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Residence since</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>NA</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>House & Building No.</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.landMark || agreement?.address?.landMark || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Street Name</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.address || agreement?.address?.address || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>City</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.cityId || agreement?.address?.cityId || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>State</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.state || agreement?.address?.state || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Locality</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.landMark || agreement?.address?.landMark || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Pin Code</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.pinCode || agreement?.address?.pinCode || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Email ID</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.email || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Mobile</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.customer?.mobileNumber || agreement?.eSign?.phoneNumber || ''}</td>
                                </tr>
                            </tbody>
                        </table>


                        <h4 style={{ marginTop: '20px' }}>Bank Details</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Bank Name</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.bankDetails?.bankName || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Account Number</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.bankDetails?.accountNumber || ''}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>IFSC Code</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.bankDetails?.ifscCode || ''}</td>
                                </tr>
                                {/* <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Branch Address</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.address?.address || ''}</td>
                                </tr> */}
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Account Type</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.bankDetails?.accountType || 'Saving'}</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4 style={{ marginTop: '20px' }}>DISBURSEMENT ACCOUNT:</h4>
                        <p>Loan will be disbursed in: {agreement?.bankDetails?.bankName || ''} - {agreement?.bankDetails?.accountNumber || ''}</p>

                        <h4 style={{ marginTop: '20px' }}>Vendor/Service Provider</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.fintech?.id || ''}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>Lending Service Provider</td>
                                    <td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.fintech?.name || ''}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="print-container">
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <table style={{ width: '100%' }}>
                                        <tbody className='styleanddesign'>
                                            <tr>
                                                <td>
                                                    <section className="section mt-5 mb-5">
                                                        <h2>KEY FACT STATEMENT</h2>
                                                        <p style={{ border: '1px solid #000', padding: '5px' }}><strong>NAME OF REGULATED ENTITY:</strong> <span> SALORA CAPITAL LIMITED</span> </p>
                                                        <p style={{ border: '1px solid #000', padding: '5px' }}>
                                                            <strong >Date:</strong> {agreement?.approval?.approvedDate || agreement?.eSign?.esignDate || new Date().toLocaleDateString()}<br />
                                                            <strong >Application Number:</strong> {agreement?.lead?.applicationId || ''}<br />
                                                            <strong >Borrower:</strong> {agreement?.customer?.borrowerName || ''}
                                                        </p>
                                                    </section>

                                                    <div className="container-fluid keyfactlayout mt-3 mb-5">
                                                        <h3>Loan Summary</h3>
                                                        <table className="styled-table mt-3 mb-3" style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                                                            <tbody>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Loan Amount</th><td style={{ border: '1px solid #000', padding: '5px' }}>₹{agreement?.approval?.loanAmount}</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Interest Rate</th><td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.roi / mapRoi(agreement?.approval?.repaymentType)}%</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Interest Type</th><td style={{ border: '1px solid #000', padding: '5px' }}>{mapRoiType(agreement?.approval?.roiType)}</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>APR</th><td style={{ border: '1px solid #000', padding: '5px' }}>{resolveApr(agreement?.approval, agreement?.lead)}</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Disbursed Amount</th><td style={{ border: '1px solid #000', padding: '5px' }}>₹{agreement?.approval?.disbursedAmount}</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Tenure</th><td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.tenure} days</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>EMI Amount</th><td style={{ border: '1px solid #000', padding: '5px' }}>₹{agreement?.approval?.emiAmount}</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Repayment Frequency</th><td style={{ border: '1px solid #000', padding: '5px' }}>{mapRepaymentType(agreement?.approval?.repaymentType || agreement?.lead?.repaymentType)}</td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Number of Installments</th><td style={{ border: '1px solid #000', padding: '5px' }}>{agreement?.approval?.numberOfEmi}</td></tr>
                                                            </tbody>
                                                        </table>

                                                        <h3>Upfront Charges</h3>
                                                        <table className="styled-table mt-3 mb-3" style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                                                            <tbody>
                                                                <tr><td style={{ border: '1px solid #000', padding: '5px' }}>Processing Charges</td><td style={{ border: '1px solid #000', padding: '5px' }}>NA</td></tr>
                                                                <tr><td style={{ border: '1px solid #000', padding: '5px' }}>Insurance Charges</td><td style={{ border: '1px solid #000', padding: '5px' }}>NA</td></tr>
                                                                <tr><td style={{ border: '1px solid #000', padding: '5px' }}>Documentation Charges</td><td style={{ border: '1px solid #000', padding: '5px' }}>NA</td></tr>
                                                                <tr><td style={{ border: '1px solid #000', padding: '5px' }}>Others</td><td style={{ border: '1px solid #000', padding: '5px' }}>NA</td></tr>
                                                            </tbody>
                                                        </table>

                                                        <h3>Contingent Charges</h3>
                                                        <table className="styled-table mt-3 mb-3" style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                                                            <tbody>
                                                                {/* <tr><td>Penal Charges</td><td>1.25% per day on overdue amount</td></tr>
                                                                <tr><td>Bounce Charges</td><td>₹650 per bounce</td></tr> */}
                                                                <tr><td style={{ border: '1px solid #000', padding: '5px' }}>Cooling-off Period</td><td style={{ border: '1px solid #000', padding: '5px' }}>3 Days</td></tr>
                                                            </tbody>
                                                        </table>

                                                        <h3>Lending Service Provider (LSP)</h3>
                                                        <table className="styled-table mt-3 mb-3" style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                                                            <tbody>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Name</th><td style={{ border: '1px solid #000', padding: '5px' }}></td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Email</th><td style={{ border: '1px solid #000', padding: '5px' }}></td></tr>
                                                                <tr><th style={{ border: '1px solid #000', padding: '5px' }}>Address</th><td style={{ border: '1px solid #000', padding: '5px' }}></td></tr>
                                                            </tbody>
                                                        </table>

                                                        <h3>Grievance Redressal</h3>
                                                        <table className="styled-table mt-3" style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <th style={{ border: '1px solid #000', padding: '5px' }}> LSP</th>
                                                                    <th style={{ border: '1px solid #000', padding: '5px' }}>Salora Capital</th>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: '1px solid #000', padding: '5px' }}>
                                                                        Grievance Officer Name <br />
                                                                        Grievance Officer Phone <br />
                                                                        Grievance Officer Email
                                                                    </td>
                                                                    <td style={{ border: '1px solid #000', padding: '5px' }}>
                                                                        Bharti Rana<br />
                                                                        9289119401<br />
                                                                        grievance@saloracapital.com
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>


                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>

                        {/* EMI schedule if available */}
                        {agreement?.approvalRepayments && agreement.approvalRepayments.length > 0 && (
                            <div style={{ marginTop: '20px' }}>
                                <h4>EMI SCHEDULE</h4>
                                <table className='emischedule mb-5' style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '1px solid #000', padding: '5px' }}>EMI No</th>
                                            <th style={{ border: '1px solid #000', padding: '5px' }}>Due Date</th>
                                            <th style={{ border: '1px solid #000', padding: '5px' }}>EMI Amount</th>
                                            <th style={{ border: '1px solid #000', padding: '5px' }}>Principal</th>
                                            <th style={{ border: '1px solid #000', padding: '5px' }}>Interest</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {agreement.approvalRepayments.map((r) => (
                                            <tr key={r.id}>
                                                <td style={{ border: '1px solid #000', padding: '5px' }}>{r.emiNumber}</td>
                                                <td style={{ border: '1px solid #000', padding: '5px' }}>{r.emiDate}</td>
                                                <td style={{ border: '1px solid #000', padding: '5px' }}>{r.emiAmount}</td>
                                                <td style={{ border: '1px solid #000', padding: '5px' }}>{r.principal}</td>
                                                <td style={{ border: '1px solid #000', padding: '5px' }}>{r.interest}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                    </div>


                    <div
                        style={{
                            position: "fixed",
                            left: "50%",
                            transform: "translateX(-50%)",
                            bottom: "16px",
                            width: "95%",
                            maxWidth: "520px",
                            zIndex: 9999,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#fff",
                                padding: "12px",
                                borderRadius: "12px",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                            }}
                        >
                            {/* Download PDF */}
                            {/* <button
      onClick={downloadPDF}
      style={{
        padding: "10px 14px",
        backgroundColor: "#0069d9",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: 600,
        width: "100%",
      }}
    >
      Download PDF
    </button> */}

                            <input type="hidden" value={applicationId} />
                            <input type="hidden" value={token} />

                            {/* eSign Button */}
                            {!isEsigned && !showOtpInput && (
                                <button
                                    onClick={generateOtp}
                                    disabled={loading}
                                    style={{
                                        padding: "10px 14px",
                                        backgroundColor: "#28a745",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        fontWeight: 600,
                                        width: "100%",
                                    }}
                                >
                                    eSign
                                </button>
                            )}

                            {/* OTP Section */}
                            {showOtpInput && (
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "8px",
                                        width: "100%",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <input
                                        value={otpValue}
                                        onChange={(e) => setOtpValue(e.target.value)}
                                        placeholder="Enter OTP"
                                        style={{
                                            flex: 1,
                                            padding: "10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ddd",
                                            minWidth: "120px",
                                        }}
                                    />

                                    <button
                                        onClick={verifyOtp}
                                        disabled={loading}
                                        style={{
                                            padding: "10px 12px",
                                            backgroundColor: "#17a2b8",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            flex: 1,
                                        }}
                                    >
                                        Verify
                                    </button>

                                    <button
                                        onClick={() => generateOtp(true)}
                                        disabled={loading}
                                        style={{
                                            padding: "10px 12px",
                                            backgroundColor: "#ffc107",
                                            color: "#000",
                                            border: "none",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            flex: 1,
                                        }}
                                    >
                                        Resend
                                    </button>
                                </div>
                            )}

                            {/* OTP Info */}
                            {otpSent && esignData?.otpSentTo && (
                                <div style={{ fontSize: "12px", color: "#555", width: "100%", textAlign: "center" }}>
                                    OTP sent to: <b>{esignData.otpSentTo}</b>
                                </div>
                            )}

                            {/* Signed Status */}
                            {isEsigned && (
                                <div style={{ color: "#28a745", fontWeight: 600, width: "100%", textAlign: "center" }}>
                                    eSigned ✓
                                </div>
                            )}
                        </div>
                    </div>

                </div>
                {/* Modal Popup */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-container">
                            <h2>Notice</h2>
                            <p>{modalMessage}</p>
                            <button className="modal-close-btn" onClick={() => setShowModal(false)}>OK</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
export default LoanAgreement;